// Shared config for Settings > Dynamic Filters and the value pack form.

// Modules that can have dynamic filters. `features` = what can be made dynamic in that module.
export const FILTER_MODULES = [
  {
    value: 'value_pack',
    label: 'Value Packs',
    features: [
      { value: 'filters', label: 'Filters' },
      // Dropdowns on the value pack detail page that change the pack price
      { value: 'price_options', label: 'Price Options' },
    ],
  },
  {
    value: 'product',
    label: 'Products',
    features: [
      // Dropdowns on the product detail page that change the package price
      { value: 'price_options', label: 'Price Options' },
    ],
  },
];

export const FILTER_TYPES = [
  { value: 'checkbox', label: 'Checkbox (pick many)' },
  { value: 'radio', label: 'Radio (pick one)' },
  { value: 'dropdown', label: 'Dropdown (pick one)' },
  { value: 'range', label: 'Range slider' },
  { value: 'sort', label: 'Sort options' },
];

// What a filter matches against on the value pack.
export const FILTER_SOURCES = [
  { value: 'custom', label: 'Custom (tag each pack in the value pack form)', builtIn: false },
  { value: 'industry', label: 'Target industries of the pack', builtIn: true },
  { value: 'category', label: 'Categories of the pack', builtIn: true },
  { value: 'price', label: 'Pack starting price', builtIn: true },
  { value: 'sort', label: 'Sorting of the list', builtIn: true },
];

// Data sources allowed for each type (mirrors the backend validation)
export const SOURCES_BY_TYPE = {
  checkbox: ['custom', 'industry', 'category'],
  radio: ['custom', 'industry', 'category'],
  dropdown: ['custom', 'industry', 'category'],
  range: ['price'],
  sort: ['sort'],
};

// Where the filter shows on the storefront page. 'sidebar' is the left sidebar.
// short = label for the compact toggle in the filter list.
export const PLACEMENTS = [
  { value: 'sidebar', label: 'Left sidebar', short: 'Left' },
  { value: 'right', label: 'Right sidebar', short: 'Right' },
  { value: 'top', label: 'Top bar', short: 'Top' },
  { value: 'bottom', label: 'Bottom bar', short: 'Bottom' },
];

// Sort options are either:
//  auto   - calculated by the storefront from pack data (price, number of products)
//  manual - packs ticked for it in the value pack form are listed first
export const AUTO_SORTS = [
  { value: 'priceHigh', label: 'Price - High to Low' },
  { value: 'priceLow', label: 'Price - Low to High' },
  { value: 'products', label: 'Number of Products' },
];

export const getSortMode = (option) =>
  option?.mode === 'auto' || option?.mode === 'manual'
    ? option.mode
    : AUTO_SORTS.some((s) => s.value === option?.value)
      ? 'auto'
      : 'manual';

// Starting options when a Sort filter is created
export const SORT_OPTIONS = [
  { value: 'relevance', label: 'Relevance', mode: 'manual' },
  { value: 'popularity', label: 'Popularity', mode: 'manual' },
  { value: 'recommended', label: 'Recommended', mode: 'manual' },
  { value: 'products', label: 'Number of Products', mode: 'auto' },
  { value: 'priceHigh', label: 'Price - High to Low', mode: 'auto' },
  { value: 'priceLow', label: 'Price - Low to High', mode: 'auto' },
];

// Same values the value pack form saves in targetIndustries (backend TARGET_INDUSTRIES)
export const DEFAULT_INDUSTRY_OPTIONS = [
  { value: 'ecommerce', label: 'E-commerce' },
  { value: 'saas', label: 'SaaS' },
  { value: 'education', label: 'Education' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'real-estate', label: 'Real Estate' },
  { value: 'finance', label: 'Finance' },
  { value: 'travel', label: 'Travel' },
  { value: 'food-delivery', label: 'Food Delivery' },
];

export const typeNeedsOptions = (type) => ['checkbox', 'radio', 'dropdown', 'sort'].includes(type);

export const slugify = (value = '') =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 60);

export const labelOf = (list, value) => list.find((item) => item.value === value)?.label || value;
